import { IStateErrorBase, IStateSuccessBase } from '@boxx/core';

export type OnboardingStateSuccessErrorType =
  | 'GET'
  | 'SAVE'
  | 'UPDATE'
  | 'UPDATE_STORE_ECWID'
  | 'UPDATE_SCORE'
  | 'UPDATE_META'
  | 'DELETE_IMAGE'
  | 'LOAD_FACEBOOK_PAGES'
  | 'UPSERT_FACEBOOK_PAGES'
  | 'REMOVE_LOGO'
  | 'REMOVE_BANNER'
  | 'REMOVE_GALLERY'
  | 'REFRESH_SITE_FIELDS'
  | 'REFRESH_IMAGES_SITE'
  | 'UNKNOWN';

export interface IOnboardingStateError extends IStateErrorBase {
  after: OnboardingStateSuccessErrorType;
}

export interface IOnboardingStateSuccess extends IStateSuccessBase {
  after: OnboardingStateSuccessErrorType;
}
